// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__lZOal","title":"style_title__ZeVTz","subtitle":"style_subtitle__SKYlK"};